import React from 'react'
import MailVerification from '../../Components/client/VerifyMail'

function VerifyMail() {
  return (
    <div>
      <MailVerification/>
    </div>
  )
}

export default VerifyMail
